/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Hohe_Landesschule_Hanau4Inputs */

const en__field__enum_schoolname_hohe_landesschule_hanau4 = /** @type {(inputs: _Field__Enum_Schoolname_Hohe_Landesschule_Hanau4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanau`)
};

const de__field__enum_schoolname_hohe_landesschule_hanau4 = /** @type {(inputs: _Field__Enum_Schoolname_Hohe_Landesschule_Hanau4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hohe Landesschule Hanau`)
};

/**
* | output |
* | --- |
* | "Hanau" |
*
* @param {_Field__Enum_Schoolname_Hohe_Landesschule_Hanau4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_hohe_landesschule_hanau4 = /** @type {((inputs?: _Field__Enum_Schoolname_Hohe_Landesschule_Hanau4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Hohe_Landesschule_Hanau4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_hohe_landesschule_hanau4(inputs)
	return de__field__enum_schoolname_hohe_landesschule_hanau4(inputs)
});
export { _field__enum_schoolname_hohe_landesschule_hanau4 as "_field__enum_schoolName_Hohe_Landesschule_Hanau" }